export default __webpack_public_path__ + "static/media/promo_06.1d5595cf.jpg";